// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__17ozB","expandIcon":"AccordionButton_expandIcon__1WZB5","expanded":"AccordionButton_expanded__3RhyI"};